import React from 'react';
import TextArea from '../../../../../form/TextArea';

export default function ObsTabPanel({ operacao, dados, handleChange, handleOnFocus, handleOnBlur, profile }) {
    const ui = profile?.uiTabs?.observacao;
    return (
        <div style={{ margin: '1em' }}>
            {ui.obsMovimento && (
                <div>
                    <TextArea
                        text={`Observações no ${operacao?.descricao ?? ''}`}
                        type="text"
                        name="obsMovimento"
                        placeholder="Digite aqui as observações"
                        title="Digite as observações"
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados?.obsMovimento || ''}
                        textAlign="left"
                        linhas="4"
                        colunas="120"
                    />
                </div>
            )}
            {ui.obsEntrada && (
                <div>
                    <TextArea
                        text={`Observações no ${operacao?.descricao ?? ''}`}
                        type="text"
                        name="obsEntrada"
                        placeholder="Digite aqui as observações"
                        title="Digite as observações"
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados?.obsEntrada || ''}
                        textAlign="left"
                        linhas="4"
                        colunas="120"
                    />
                </div>
            )}
            {ui.obsSaida && (
                <div>
                    <TextArea
                        text={`Observações no ${operacao?.descricao ?? ''}`}
                        type="text"
                        name="obsSaida"
                        placeholder="Digite aqui as observações"
                        title="Digite as observações"
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados?.obsSaida || ''}
                        textAlign="left"
                        linhas="4"
                        colunas="120"
                    />
                </div>
            )}
            {ui.obsServico && (
                <div style={{ marginTop: '1em' }}>
                    <TextArea
                        text={`Descrição do ${operacao?.descricao ?? ''}`}
                        type="text"
                        name="obsServico"
                        placeholder="Digite aqui as observações"
                        title="Digite as observações"
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados?.obsServico || ''}
                        textAlign="left"
                        linhas="4"
                        colunas="120"
                    />
                </div>
            )}
            {ui.obsRequisicao && (
                <div style={{ marginTop: '1em' }}>
                    <TextArea
                        text={`Observações da ${operacao?.descricao ?? ''}`}
                        type="text"
                        name="obsRequisicao"
                        placeholder="Digite aqui as observações"
                        title={`Digite as observações necessárias para a execução do ${operacao?.descricao ?? ''}`}
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados?.obsRequisicao || ''}
                        textAlign="left"
                        linhas="4"
                        colunas="120"
                    />
                </div>
            )}
            {ui.obsLancamento && (
                <div style={{ marginTop: '1em' }}>
                    <TextArea
                        text={`Observações nos lançamentos ${operacao?.descricao ?? ''}`}
                        type="text"
                        name="obsLancamento"
                        placeholder="Digite aqui as observações"
                        title={`Digite as observações necessárias para o lançamento do ${operacao?.descricao ?? ''}, aparecerá no modulo financeiro`}
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados?.obsLancamento || ''}
                        textAlign="left"
                        linhas="4"
                        colunas="120"
                    />
                </div>
            )}
        </div>
    );
}
